import React from "react";
import {
  FormControl,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  Input,
  OutlinedInput,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import FilterListIcon from '@mui/icons-material/FilterList';

export default function SelectableMultiSelect(props) {
  const {
    multiple = true,
    fieldLabel = "label",
    name,
    value,
    size = "small",
    variantType = "standard",
    onChangeEvent,
    data,
    loading,
    isOptionEqualToValue,
    styles,
    menuHeight = 180,
    label,
  } = props;
  const [open, setOpen] = React.useState(false);

  const triggerLoading = open && data?.values?.length === 0;

  React.useEffect(() => {
    if (!triggerLoading) return;
    loading && loading();
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [triggerLoading]);

  const compareFn =
    isOptionEqualToValue ||
    ((opt, val) => opt?.[fieldLabel] === val?.[fieldLabel]);

  const currentValue = multiple
    ? Array.isArray(value)
      ? value
      : []
    : value || null;

  const handleSelectToggle = (option) => {
    let updated = [];

    if (multiple) {
      const exists = currentValue.some((item) => compareFn(option, item));

      updated = exists
        ? currentValue.filter((item) => !compareFn(item, option))
        : [...currentValue, option];
    }

    onChangeEvent(name, updated);
  };

  const clearAll = (e) => {
    e.stopPropagation();
    onChangeEvent(name, []);
  };

  return (
    <FormControl fullWidth size={size} sx={{ position: "relative", ...styles}}>
      <Select
        labelId={`${name}-label`}
        label={label}
        multiple
        variant={variantType}
        open={open}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        value={currentValue}
        displayEmpty
       input={variantType === "outlined" ? <OutlinedInput /> : <Input />}
        sx={{
          // "& .MuiInputBase-input": {
          //   padding: "0px !important",
          // },
          width: "100%",
          maxWidth: "100%",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          pr: "45px",
          pl: "4px",
          textAlign: 'start'
        }}
        renderValue={(selected) => {
          if (!selected || selected.length === 0) {
            return (
              <span style={{ display: "flex", alignItems: "center", opacity: 0.7 }}>
                <FilterListIcon fontSize="small" style={{ marginRight: 6 }} />
                {label || "Select"}
              </span>
            );
          }

          return selected.map((x) => x?.[fieldLabel]).join(", ");
        }}

        MenuProps={{
          PaperProps: {
            style: {
              maxHeight: menuHeight,
            },
          },
        }}
      >
        {data?.load && (
          <MenuItem>
            Loading...
          </MenuItem>
        )}
        {!data?.load && (data?.values?.length === 0 ) && (
          <MenuItem>
            No options
          </MenuItem>
        )}
        {/* SELECT ALL OPTION */}
        {!data?.load && data?.values?.length > 0 && (
          <MenuItem
            key="select-all"
            onClick={() => {
              const allSelected = currentValue.length === data.values.length;

              if (allSelected) {
                onChangeEvent(name, []);
              } else {
                onChangeEvent(name, [...data.values]);
              }
            }}
            sx={{
              height: 32,
              minHeight: 32,
              display: "flex",
              alignItems: "center",
            }}
          >
            <Checkbox
              size="small"
              checked={
                currentValue.length === data.values.length &&
                data.values.length > 0
              }
              indeterminate={
                currentValue.length > 0 &&
                currentValue.length < data.values.length
              }
            />
            <ListItemText primary="Select All" />
          </MenuItem>
        )}

        {data?.values?.map((option) => {
          const isSelected = currentValue?.some((item) =>
            compareFn(option, item)
          );

          return (
            <MenuItem
              key={option?.[fieldLabel]}
              value={option}
              sx={{
                height: 32,
                minHeight: 32,
                display: "flex",
                alignItems: "center",
              }}
            >
              <Checkbox
                size="small"
                checked={isSelected}
                onClick={(e) => {
                  e.stopPropagation();
                  handleSelectToggle(option);
                }}
              />
              <ListItemText primary={option?.[fieldLabel]} />
            </MenuItem>
          );
        })}
      </Select>

      {/* Clear All Icon */}
      {currentValue?.length > 0 && (
        <IconButton
          size="small"
          onClick={clearAll}
          sx={{
            position: "absolute",
            right: 25,
            top: "55%",
            transform: "translateY(-50%)",
            padding: "2px",
            height: 22,
            width: 22,
          }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      )}
    </FormControl>
  );
}
